import React, { Component } from "react";
// 接口以及调用接口方法
import { powerlossQry } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// icon
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
// 组件
import ElecticalLossLine from "@/pages/displayBoard/electicalLossLine";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class ElecticalLossBoard extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      param: {
        cityIds: this.props.param.cityIds,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      queryDate: {
        actualLossPower: 0, // 电损电量
        actualLossPowerChain: 0, // 电损电量环比
        actualLossPowerRate: 0, // 运行电损率
        actualLossPowerRateChain: 0, // 运行电损率环比
        meterPower: 0, // 总电量/电表电量
        meterPowerChain: 0, // 总电量/电表电量环比
        orderPower: 0, // 订单电量
        orderPowerChain: 0, // 订单电量环比
        theoryLossPowerRate: 0, // 理论电损率
        theoryLossPowerRateChain: 0, // 理论电损率环比
      },
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds
      && nextProps.param.cityIds === this.state.param.cityIds
      && nextProps.param.operationProperty === this.state.param.operationProperty
      && nextProps.param.operationMode === this.state.param.operationMode
      && nextProps.param.date === this.state.param.date
    ) {
      console.log("一样");
    } else {
      console.log("不一样");
      this.setState(
        {
          param: {
            cityIds: nextProps.param.cityIds,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          // 获取数据
          this.getPowerlossQry();
        },
      );
    }
  }

  // 页面加载前获取充电成功率数据
  componentWillMount() {
    this.getPowerlossQry();
  }

  // 获取数据
  getPowerlossQry() {
    // 获取成功率数据1
    fetchHandler(powerlossQry, {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      console.log(res);
      if (res.data) {
        this.setState({
          queryDate: {
            actualLossPower: res.data.actualLossPower, // 电损电量
            actualLossPowerChain: res.data.actualLossPowerChain, // 电损电量环比
            actualLossPowerRate: res.data.actualLossPowerRate, // 运行电损率
            actualLossPowerRateChain: res.data.actualLossPowerRateChain, // 运行电损率环比
            meterPower: res.data.meterPower, // 总电量/电表电量
            meterPowerChain: res.data.meterPowerChain, // 总电量/电表电量环比
            orderPower: res.data.orderPower, // 订单电量
            orderPowerChain: res.data.orderPowerChain, // 订单电量环比
            theoryLossPowerRate: res.data.theoryLossPowerRate, // 理论电损率
            theoryLossPowerRateChain: res.data.theoryLossPowerRateChain, // 理论电损率环比
          },
        });
      }
    });
  }

  // 数据展示箭头样式设置
  formatterClassBorad = (value) => {
    let className = "";
    if (value === 0) {
      className = "item-rate none";
    } else if (value > 0) {
      className = "down-out-line item-rate";
    } else {
      className = "down-up-line item-rate";
    }
    return className;
  }

  // 数据格式化方法
  formatterDate(value) {
    // 判断value 是正数还是复数
    const valueInt = parseInt(value);
    const flag1 = valueInt < 0; // value是否为负数
    const flag2 = flag1 ? valueInt < -100000 : valueInt > 100000; // 判断value位数 是否大于十万位
    const flag3 = flag1 ? valueInt < -1000000000 : valueInt > 1000000000; // 判断value位数 是否大于十亿位
    const flag4 = flag1 ? valueInt < -100000000000 : valueInt > 100000000000; // 判断value位数，是否大于千亿
    const flag5 = flag1
      ? valueInt < -100000000000000 : valueInt > 100000000000000; // 判断value位数，是否大于百万亿
    if (flag5) {
      return `${parseInt(valueInt / 1000000000000)}T`;
    } else if (flag4) {
      return `${parseInt(valueInt / 1000000000)}B`;
    } else if (flag3) {
      return `${parseInt(valueInt / 1000000)}M`;
    } else if (flag2) {
      return `${parseInt(valueInt / 10000)}K`;
    } else {
      return valueInt;
    }
  }

  render() {
    const content = (
      <div className="board-inner electicalLossBoard">
        <div className="order-part ">
          <div className="order-item line2">
            <div className="item-title">总电量(度)</div>
            <div className="item-num">
              {this.formatterDate(this.state.queryDate.meterPower)}
            </div>
            <div
              className={this.formatterClassBorad(this.state.queryDate.meterPowerChain)}
            >
              环比
              <span className="rate-num">
                {
                  this.state.queryDate.meterPowerChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate.meterPowerChain)}%`
                }
                {
                this.state.queryDate.meterPowerChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                this.state.queryDate.meterPowerChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item line2">
            <div className="item-title">电损电量(度)</div>
            <div className="item-num">
              {this.formatterDate(this.state.queryDate.actualLossPower)}
              <span></span>
            </div>
            <div
              className={this.formatterClassBorad(this.state.queryDate.actualLossPowerChain)}
            >
              环比
              <span className="rate-num">
                {
                  this.state.queryDate.actualLossPowerChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate.actualLossPowerChain)}%`
                }
                {
                  this.state.queryDate.actualLossPowerChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate.actualLossPowerChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item line3">
            <div className="item-title">订单电量(度)</div>
            <div className="item-num">
              {this.formatterDate(this.state.queryDate.orderPower)}
            </div>
            <div
              className={this.formatterClassBorad(this.state.queryDate.orderPowerChain)}
            >
              环比
              <span className="rate-num">
                {
                  this.state.queryDate.orderPowerChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate.orderPowerChain)}%`
                }
                {
                  this.state.queryDate.orderPowerChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate.orderPowerChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item line3">
            <div className="item-title">运行电损率</div>
            <div className="item-num">
              {this.state.queryDate.actualLossPowerRate}<span>%</span>
            </div>
            <div
              className={this.formatterClassBorad(this.state.queryDate.actualLossPowerRateChain)}
            >
              环比
              <span className="rate-num">
                {
                  this.state.queryDate.actualLossPowerRateChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate.actualLossPowerRateChain)}%`
                }
                {
                  this.state.queryDate.actualLossPowerRateChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate.actualLossPowerRateChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item line3">
            <div className="item-title">理论电损率</div>
            <div className="item-num">
              {this.state.queryDate.theoryLossPowerRate}<span>%</span>
            </div>
            <div
              className={this.formatterClassBorad(this.state.queryDate.theoryLossPowerRateChain)}
            >
              环比
              <span className="rate-num">
                {
                  this.state.queryDate.theoryLossPowerRateChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate.theoryLossPowerRateChain)}%`
                }
                {
                  this.state.queryDate.theoryLossPowerRateChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate.theoryLossPowerRateChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
        </div>
        <div className="line-title">近7天电损趋势</div>
        <div className="line-part">
          <ElecticalLossLine param={this.state.param} />
        </div>
      </div>
    );

    return content;
  }
}

export default injectIntl(ElecticalLossBoard);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/electicalLossBoard.js